import Fetcher from "./Shared/FetchService";
const engagementUrl = "/aviso/engagement/";
class EngagementService {
    static getStudentsByEngagementDate(params) {
        return Fetcher.getSingleResponse(engagementUrl + "studentsByEngagementDate", params);
    }
    // prettier-ignore
    static getAllStudentsByEngagementDate(params) {
        return Fetcher.getSingleResponse(engagementUrl + "allStudentsByEngagementDate", params);
    }
    // prettier-ignore
    static getCaseloadModalFilters() {
        return Fetcher.getSingleResponse(engagementUrl + "caseloadEngagementFilters");
    }
    static setCaseloadModalFilters(daysAgo, registrationTerms) {
        return Fetcher.postSingleResponse(engagementUrl + "setCaseloadEngagementFilters", { daysAgo, registrationTerms });
    }
    static getKeyEngagementScoresByTeam(params) {
        return Fetcher.getSingleResponse(engagementUrl + "getKeyEngagementScoresByTeam", params);
    }
    // prettier-ignore
    static getKeyEngagementScoresByTeamModalFilter() {
        return Fetcher.getSingleResponse(engagementUrl + "keyEngagementScoresByTeamModalFilter");
    }
    static setKeyEngagementScoresByTeamFilter(params) {
        return Fetcher.postSingleResponse(engagementUrl + "setKeyEngagementScoresByTeamFilter", params);
    }
    static getTeamEngagementModalFilter() {
        return Fetcher.getSingleResponse(engagementUrl + "teamEngagementModalFilter");
    }
    static setTeamEngagementModalFilter(params) {
        return Fetcher.postSingleResponse(engagementUrl + "setTeamEngagementModalFilter", params);
    }
    static getKeyEngagementPerformance(params) {
        return Fetcher.getSingleResponse(engagementUrl + "getKeyEngagementPerformance", params);
    }
}
EngagementService.getFilterSettingsFromRaw = (settings, includeTeams) => {
    const tempSettings = {
        lastKeyEngagementMaxDaysAgo: 30,
        registrationTerms: [],
        teams: [],
    };
    if (!includeTeams) {
        delete tempSettings.teams;
    }
    settings.forEach((filter) => {
        if (filter.EngagementDays) {
            tempSettings.lastKeyEngagementMaxDaysAgo = parseInt(
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
            filter.EngagementDays, 10);
        }
        if (filter.Team) {
            if (!tempSettings.teams) {
                tempSettings.teams = [filter.Team];
            }
            else {
                tempSettings.teams.push(filter.Team);
            }
        }
        if (filter.EngagementRegistrationTerm) {
            tempSettings.registrationTerms.push(filter.EngagementRegistrationTerm);
        }
    });
    return tempSettings;
};
export default EngagementService;
